<template>
	<header id="commonhead">
		<!--logo-->
		<div id="headlogo">
			<img src="../assets/images/logo.png"/>
		</div>
		<!--导航-->
		<nav id="headnav">
			<el-menu :default-active="$route.path" class="el-menu-demo" :router='true' mode="horizontal"  background-color="#080C18" text-color="#fff" active-text-color="#066AF3">
				<el-menu-item index="/">首页</el-menu-item>
				<!--<el-menu-item index="/demo">实例</el-menu-item>-->
				<el-menu-item index="/pricing">价格</el-menu-item>
				<el-menu-item index="/down">下载</el-menu-item>
				<!-- <el-menu-item index="/developdocument">帮助</el-menu-item> -->
			  <a href="http://www.bytev.cn/index.php?app=shop" target="_blank" class="bytev-basics">实例</a>

			  <a href="http://bytev-beta.bytev.cn/" target="_blank" class="bytev-basics">ByteV基础版</a>
			  <a href="http://www.bytevcharts.com/" target="_blank" class="bytev-basics">ByteVCharts</a>
			  <a href="http://bytev.cn/" target="_blank" class="bytev-basics">ByteV社区</a>

			</el-menu>
		</nav>
		<!--登录-->
		<div id="headright">
			<a class="top_head_picture" v-if="!isShowLogin">
				<img v-if="portrait == ''" src="../assets/images/head.png" />
				<img v-if="portrait != ''" :src="apiUrl+portrait"/>
			</a>
			<span style="cursor: pointer;" v-show="isShowLogin" @click="loginDG" id="home_login_button">登录</span>
			<span style="cursor: pointer;" v-show="isShowLogin" @click='goRegisterPage' id="home_register_button">注册</span>
			<a style="color: white;cursor: pointer;" v-show="!isShowLogin" @click="gotovip">{{id}}</a>
			<a style="cursor: pointer;" id="home_head_bell" v-show="!isShowLogin" @click="gonewspage"><i class="el-icon-bell"></i><el-badge is-dot class="item" v-show="isDot"></el-badge></a>
			<a style="cursor: pointer;" id="home_head_exit" v-show="!isShowLogin" @click="LogouDG">退出</a>
		</div>
		<!--
        	作者：Robin
        	时间：2018-10-13
        	描述：登录界面弹窗
        -->
		<div id="login_wrap" v-show="flag">
			<div id="login_box">
				<div class="login_wrap_top">
				<span id="l_t1" style="float: left;display: block;"><h4>登录</h4></span>
				<span id="l_t2" style="float: right;display: block;color: #AAAAAA;cursor: pointer;" @click="cancelloginDG" title="点击关闭"><i class="el-icon-close"></i></span>
				</div>
			<div class="login_wrap_main">
				<div class="phonenum">
					<input autocomplete="off" type="text" placeholder="手机号" @blur="phoneVerification" v-model="phone"/>
					<span id="login_phonem" style="float: left;"></span>
				</div>
				<div class="phonenum">
					<input autocomplete="off" type="password" placeholder="密码" @blur="passwordVerification" v-model="password"/>
					<span id="login_pwdm" style="float: left;"></span>
				</div>
				<div class="userdefault">
					<span>
						<span id="checkbox">
							<input  type="checkbox" v-model="remember_username" @click="rememberUsername"/>
						</span>

						<a >记住帐号</a>
					</span>
					<a  class="reu" style="color: #217FF3;cursor: pointer;float: right;" @click="retrievepassword">忘记密码</a>
				</div>
				<div class="loginbtn">
					<button @click='logIn' style='background:#0674F2 ;color: white;' class='loadstates loadstates1' :loading='!true' type='primary' v-show="loadstates">登录中</button>
					<button @click='logIn' id='d_l' class='loadstates' type='primary' v-show="!loadstates">登录</button>
					<button class='loadstates' type='primary' @click='goRegisterPage' >注册</button>
				</div>
			</div>
			</div>
		</div>
		<!--右侧菜单 -->

		<retrievepassword ref='retrievepassword'></retrievepassword>
	</header>
</template>

<script type="text/javascript">
	import Bus from '@/bus.js'
	import '../router/jquery-3.3.1.min.js'
	import retrievepassword from '@/messageBox/retrievepassword.vue'
	export default {
		data() {
			return {
				apiUrl:this.apiUrl,
				activeIndex: '/',
				activeIndex2: '/',
				flag:false,
				loadstates:false,
				isShowLogin:true,
				id:'',
				phone:'',		//手机号
				password:'',	//密码
				portrait:'',	//头像
				remember_username:false,	//是否记住登录
				rememberShow:false,
				isDot:false,		//是否显示有新消息
			};
		},
		components:{
			retrievepassword
		},
		created(){
			// console.log('66665')
			// this.F12();
			let _this = this;
			 window.socket.on('new_msg', function(msg){
		        window.socket_dot=true;
		       	sessionStorage.removeItem('socket_dot')
		       	sessionStorage.setItem('socket_dot',true)
		        Bus.$emit('socket_dot',sessionStorage.getItem('socket_dot'))
		    });
		    Bus.$on('socket_dot',data => {
		    	_this.isDot = data;
		    });
		     Bus.$on('first_dot',data => {
		    	_this.isDot = data;
		    });
			Bus.$on('portrait',(data) => {
				_this.portrait=data.portrait;
			});

			Bus.$emit('showmore',(data) => {
				_this.flag=data.flag;
			});

			Bus.$emit('dot',(data) => {
				_this.isDot=data.isDot;
			});
		},
		mounted() {
			 if(sessionStorage.getItem('socket_dot')){
			 	 Bus.$emit('socket_dot',sessionStorage.getItem('socket_dot'))
			 }
			if(localStorage.getItem('phone') != null && localStorage.getItem('password') != null ){
					this.remember_username=true;
			}else{
				this.remember_username=false;
			}
			let ele1=document.getElementById('home_register_button');
			let ele=document.getElementById('home_login_button');
			if(this.$route.path == '/atlasdetails'){
				let demo=document.getElementById('demo');
				demo.className = 'el-menu-item is-active'
				demo.style.background='rgb(8, 12, 24)';
				demo.style.color='rgb(6, 106, 243)';
				demo.style.borderBottomColor='rgb(6, 106, 243)';

			}

			if(this.$route.path != '/register'){
				ele1.style.background='#080C18';
				ele1.style.color='#076BF2';
				ele.style.background='#076BF2';
				ele.style.color='white';
			}else{
				ele.style.background='#080C18';
				ele.style.color='#076BF2';
				ele1.style.background='#076BF2';
				ele1.style.color='white';
			}
			let _this = this;
			if(sessionStorage.getItem('usercode') != null){
				this.id = sessionStorage.getItem('phone');
				this.portrait = sessionStorage.getItem('portrait');
				this.flag = false;
				this.isShowLogin=false;

				if(sessionStorage.getItem('isDot') != null){
					this.isDot = sessionStorage,getItem('isDot');
				}else{
					//获取是否有新消息
					this.$http.get(
						_this.apiUrl+'index.php?m=Api&c=user&a=getInformType',
						{
							params: {
								'userCode':sessionStorage.getItem('usercode')
							}
						}
					).then(response => {

						//进行数据验证
						if(response.body.status == 1){
//							sessionStorage.setItem('isDot',true);
//							this.isDot = true;
						}

					}, response => {
//						alert('请求错误');
					});
				}
			};

//			this.rememberShow = true;
			Bus.$on('sendLoginStates',(data)=>{
				_this.isShowLogin=data.show;
				_this.id=data.phone;
				_this.portrait = sessionStorage.getItem('portrait');
				_this.flag = false;
			})
		},
		beforeUpdate(){


			if(localStorage.getItem('phone') != null && localStorage.getItem('password') != null ){

				this.phone = localStorage.getItem('phone');

				this.password = localStorage.getItem('password');
			}

		},
		methods: {
			F12(){
				//监听F12
				window.onkeydown = window.onkeyup = window.onkeypress = (event)=> {
					// 判断是否按下F12，F12键码为123
					if(event.keyCode == 123) {
						//byteV_F12();
						this.$message({
							message: ' ByteV版权所有！ 请尊重他人劳动成果！',
							type: 'warning'
						});

						event.preventDefault(); // 阻止默认事件行为
						window.event.returnValue = false;
						//监听ctrl和shift和i
					}else if(event.ctrlKey == 1 && event.shiftKey==1 && event.keyCode === 73) {
							this.$message({
							message: ' ByteV版权所有！ 请尊重他人劳动成果！',
							type: 'warning'
						});

					}
				}
				// 为右键添加自定义事件，可以禁用
				window.oncontextmenu = function() {
					// 阻止默认事件行为
					event.preventDefault();
					return false;
				}
				var threshold = 160; // 打开控制台的宽或高阈值
				// 每秒检查一次
				setInterval(function() {
					if(window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
						// 如果打开控制台，则刷新页面
						//window.location.reload();
						//让浏览器崩溃
						var total="";
						for (var i=0;i<1000000;i++){
						 	total= total+i.toString();
						 	history.pushState(0,0,total);
						}
					}
				}, 1e3);
			},
			//手机号格式验证
			phoneVerification() {
				let that = this;
				let message = document.getElementById('login_phonem')
				let reg = /^1[3-9]{1}[0-9]{9}$/;
				if(that.phone) {
					if(reg.test(that.phone)) {
						message.innerText = '';
						return true;
					} else {
						message.innerText = '请输入正确的手机号'
						return false;
					}
				} else {
					message.innerText = '手机号不能为空'
					return false;
				}
			},
			//密码格式验证
			passwordVerification() {
				let that = this;
				let message = document.getElementById('login_pwdm')
				let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				if(that.password) {
					if(reg.test(that.password)) {
						that.password_verification_flag = 1;
						message.innerText = ''
						return true
					} else {
						message.innerText = '密码格式错误'
						return false
					}
				} else {
					message.innerText = '密码不能为空'
					return false
				}
			},
			//点击弹出登录窗口
			loginDG() {
				if(this.$route.path==='/register'){
					this.$router.push('/enterPage')
					let ele1=document.getElementById('home_register_button');
					let ele=document.getElementById('home_login_button');
					ele1.style.background='#080C18';
					ele1.style.color='#076BF2';
					ele.style.background='#076BF2';
					ele.style.color='white';
				}else{
					if(this.$route.path==='/enterPage'){
						return
					}else{
						this.flag = true
					}
				}
			},
			//点击弹窗右上角叉号关闭登录窗口
			cancelloginDG() {
				this.flag = false;
				let message = document.getElementById('login_phonem')
				let message1 = document.getElementById('login_pwdm')
				this.phone='';
				this.password='';
				message.innerText='';
				message1.innerText='';
			},
			//记住密码
			rememberUsername() {
				this.remember_username = !this.remember_username
			},
			//忘记密码
			retrievepassword() {
				this.flag = false;
				this.$refs.retrievepassword.openretrievesteponepop()
			},
			//退出登录
			LogouDG() {
				this.phone='';
				this.password='';
				sessionStorage.clear()
				sessionStorage.removeItem("usercode");
				this.isShowLogin=true;
				this.$router.push('/enterPage')
			},
			//注册
			goRegisterPage() {
				let ele=document.getElementById('home_register_button');
				let ele1=document.getElementById('home_login_button');
				ele1.style.background='#080C18';
				ele1.style.color='#076BF2';
				ele.style.background='#076BF2';
				ele.style.color='white';
				this.flag = false;
				this.$router.push('/register')
			},
			//个人中心
			gotovip() {
				this.$router.push('/usercenter')
			},
			//消息通知
			gonewspage(){
				sessionStorage.removeItem('socket_dot');
				this.isDot = false;
				if(this.$route.path != '/usercenter'){
					this.$router.push({
					path: '/usercenter',
					query: {
						type: 'inform'
					}
				})
				}else{

					Bus.$emit('News',{type: 'inform'})
				}
			},
			//登录
			logIn(){
				let _this=this;
				//验证手机号和密码格式...
				if(this.phoneVerification()&&this.passwordVerification()){
					this.loadstates=false;
					//执行登录
					this.$http.get(
					_this.apiUrl+'index.php?m=Api&c=login&a=login',
					{
						params: {
							"phone":this.phone,
							"password":this.password
						}
					}
				).then(response => {
					//进行数据验证
					if(response.body.status != 1){

						//提示错误信息
						this.$message({
								message: '帐号或密码错误',
								type: 'warning',
								customClass: 'message-warning',
							});

//						alert(response.body.message);
						return;
					}
						this.loadstates=true;
					//是否记住登录
					if(this.remember_username){
						localStorage.setItem('password',this.password);
						localStorage.setItem('phone',this.phone);
					}else{
						localStorage.removeItem('password');
						localStorage.removeItem('phone');
					}

					//保存用户信息
					sessionStorage.setItem('usercode',response.body.data.userCode);
					sessionStorage.setItem('portrait',response.body.data.portrait);
					sessionStorage.setItem('phone',this.phone);
					this.loadstates=false;
					$.ajax({
						type:'post',
						data:{usercode:sessionStorage.getItem('usercode')},
						url:_this.apiUrl+'index.php?m=Api&c=Content&a=openDemo',
						success: function(data){
								if(data.status==1){
									sessionStorage.setItem('socket_dot',true)
									Bus.$emit('first_dot',sessionStorage.getItem('socket_dot'))
								}else{
		//							console.log(data);
								}
							},
						error:function(){
	//						console.log(data);
						}
					})
					this.$message({
								message: '登录成功',
								type: 'success',
								customClass: 'message-warning',
							});
					this.id = sessionStorage.getItem('phone');
					this.portrait = sessionStorage.getItem('portrait');
					this.flag = false;
					this.isShowLogin=false;

				}, response => {
//					alert('请求错误');

				});
				}



			},
		},
	}
</script>


<style>
	:not(p){
		margin: 0;
		padding: 0;
	}
	/*{
		margin: 0;
		padding: 0;
	}*/
	html,
	body {
		height: 100%;
		/*background: #f3f3f3;*/
		width: 100%;
	}
	#home_head_bell{
		display:  inline-block;width: 30px;height: 60px;color: white;font-size: 18px;padding: 0 10px;
	}
	#home_head_exit{
		padding: 5px 20px;border: 1px solid #038DF2;border-radius: 20px;font-size: 14px;color:#038DF2 ;
	}
	#d_l{
		color: white;
		font-weight: 600;
		background: #076BF2;
		/*border: 0;*/
	}

	header {
		position: fixed;
		width: 100%;
		min-width: 1500px;
		height: 70px;

		background: #080C18;
		border-bottom: 2px solid #192A55;
		overflow: hidden;
		top: 0;
		z-index: 100;
	}

	#headlogo {
		float: left;
		height: 70px;
		width: 375px;
		background: #080C18;
		margin:19px 37px ;
	}
	#headlogo>img{
		/* width: 375px; */
		height: 32px;
		display: block;
	}
	#headnav {
		float: left;
		margin-left: 80px;
	}

	#headright {
		overflow: hidden;
		/*cursor: pointer;*/
		float: right;
		margin-right: 10px;
		line-height: 70px;
		height: 70px;
	}
	#headright>.top_head_picture{
		margin: 15px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 4px solid #093270;
		float: left;
	}
	#headright>.top_head_picture>img{
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	#home_login_button{
	    color: white;
	    width: 90px;
	    height: 32px;
	    line-height: 32px;
	    background: #076bf2;
	    display: inline-block;
	    border-radius: 16px;
	    font-size: 16px;
	}
	#home_register_button{
		display: inline-block;
	    border-radius: 16px;
	    font-size: 16px;
		width: 90px;
		height: 32px;
		line-height: 32px;
		background: #080C18;
		color: #066AF3;
	}
	#headnav>.el-menu-demo{
		border: 0;
	}
	/* Robin 20181013 登录样式     start*/
	#login_wrap{
		z-index: 999;
		background: rgba(0,0,0,.5);
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
	}
	#login_box{
		background: white;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 320px;
		border-radius: 5px;
	}
	#login_box>.login_wrap_top>span{
		height: 40px;
		line-height: 40px;
	}
	#l_t1{
		font-size: 18px;
	}
	#l_t2{
		font-size: 24px;
	}
	#login_wrap .login_wrap_top{
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	#login_wrap .login_wrap_main {
		width:354px ;
		margin: 38px auto;
		height: 67px;
	}
	#login_wrap .login_wrap_main .phonenum{
		width:354px ;
		height: 67px;
		font-size: 14px;
	}
	.login_wrap_main .phonenum>input{
		border-radius: 4px;
		width: 332px;
		height: 45px;
		border: 1px solid #AAAAAA;
		outline: ;
		padding: 0 10px;
	}
	.login_wrap_main .phonenum span{
		width: 354px;
		height: 20px;
		font-size: 16px;
		line-height: 20px;
		color: red;
		text-align: left;
	}
	.userdefault{
		width: 354px;
		height: 20px;
		line-height:20px ;
		margin-bottom: 20px;
	}
	.userdefault span{
		float: left;
		height: 20px;
		line-height:20px ;
		margin-right: 180px;
	}
	.userdefault #checkbox{
		margin-right: 0;
		/*width: 200px;*/
		/*float: left;*/
		height: 20px;
		line-height: 20px;
		/*display: inline-block;*/
	}
	.userdefault span input{
		width: 16px;
		height: 16px;
		padding: 0;
		margin: 0;
		border: 0;
		outline: none;
		vertical-align: text-top;
	}
	.userdefault>a{
		font-size: 16px;
	}
	.userdefault span a{
		/*display: inline-block;*/
		line-height: 16px;
		font-size: 16px;
	}

	.loginbtn>button{
		width: 160px;
		height: 38px;
		line-height: 38px;
		padding: 0;
		border-radius: 20px;
		border: 0;
		outline: none;
		/*border: solid 1px #CCCCCC;*/
		background: #F0F0F0;
		outline: none;
		margin: 0 4px;
		font-size: 16px;
		color: black;
	}
	.loginbtn>button:hover{
		background: #076bf2;
		color: white;
		font-weight: 600;
	}
	.loginbtn .loadstates1{
		padding:10px 60px;
	}

	#headnav .el-menu--horizontal>.el-menu-item{
		height: 68px;
		line-height: 68px;
		font-size: 16px;

	}
	#headnav .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 6px solid #409EFF;
}
body{position:relative;font-size:14px;background-color:white;overflow:auto;}
body, button, input, keygen, legend, select, textarea{
    font-family:"Microsoft Yahei","HanHei SC",PingHei,"PingFang SC","Helvetica Neue",Helvetica,Arial,"Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif;
    font-weight:400;
    color:#333;
    outline:0;
    speak:none;
    -webkit-font-feature-settings:normal;
    -moz-font-feature-settings:normal;
    font-feature-settings:normal;
    font-variant:normal;
    text-transform:none;
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale;
}
.bytev-basics{
  color: #FFFFFF !important;
  border-bottom-color: transparent;
  height: 0.906667rem;
  line-height: 0.906667rem;
  font-size: 0.213333rem;
  padding: 0 0.266667rem;
  cursor: pointer;

}
li{list-style:none;}
html, body, fieldset, img, iframe, abbr{border:0;}
img{vertical-align:top;}
a, button{cursor:pointer;}
a{color:#333;outline:none;text-decoration:none;}
a:focus{ color:#333;
     outline:none;
     -moz-outline:none;
}
</style>



// WEBPACK FOOTER //
// src/components/commonhead.vue